import { all, takeLatest } from 'redux-saga/effects';

import { settingsActions } from '../index';
import edit from './edit';

const settingsSagas = all([takeLatest(settingsActions.editRequest, edit)]);

export default settingsSagas;
